module.exports = __webpack_public_path__ + "static/media/03.f77b5387.png";